import { render, staticRenderFns } from "./Proveedor.vue?vue&type=template&id=592ee8f1&scoped=true&"
import script from "./Proveedor.vue?vue&type=script&lang=js&"
export * from "./Proveedor.vue?vue&type=script&lang=js&"
import style0 from "./Proveedor.vue?vue&type=style&index=0&id=592ee8f1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "592ee8f1",
  null
  
)

export default component.exports